import {
  ArrowBack,
  Business,
  Category,
  Search as SearchIcon,
  Description,
  Event,
} from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled, { keyframes, StyleSheetManager } from "styled-components";

import NewWindow from "react-new-window";

import "react-tabs/style/react-tabs.css";
import fetchClient from "../../api/fetchClient";
import Loader from "../../components/Loader";

import LogEvents from "../../components/LogEvents";
import SearchLogs from "../../components/SearchLogs";

import message from "../../helper/message";

const STAGE = (process.env.REACT_APP_STAGE || "dev").toLowerCase();

const LOG_TYPE_TEMPLATES = [
  {
    value: "master",
    description: "Dados Mestres",
  },
  {
    value: "webhook/buying/purchase",
    description: "Purchase Buying",
  },
  {
    value: "webhook/sourcing/purchase",
    description: "Purchase Sourcing",
  },
  {
    value: "webhook/sourcing/businessPartner",
    description: "Business Partner",
  },
];

const getGroupIdentifier = (item) => item?.groupId ?? item?.grupoId ?? item?.id;

const getGroupLabel = (item) =>
  item?.groupId ?? item?.grupoId ?? item?.name ?? item?.id;

const normalizeAribaGroups = (items = []) => {
  if (!Array.isArray(items) || items.length === 0) {
    return items;
  }

  const hasGroupId = items.some(
    (item) =>
      item &&
      (item.groupId !== undefined ||
        item.groupId !== null ||
        item.grupoId !== undefined ||
        item.grupoId !== null)
  );

  if (!hasGroupId) {
    return items;
  }

  const grouped = items.reduce((acc, item) => {
    if (!item) {
      return acc;
    }

    const groupKey = getGroupIdentifier(item);
    if (groupKey === undefined || groupKey === null) {
      return acc;
    }

    const normalizedKey = `${groupKey}`;
    if (!acc[normalizedKey]) {
      const rawGroupId = `${item.groupId ?? item.grupoId ?? groupKey}`;
      acc[normalizedKey] = {
        id: normalizedKey,
        groupId: rawGroupId,
        label: getGroupLabel(item),
        groupPath: `/ariba-b1-${STAGE}/${rawGroupId}`,
      };
    }

    return acc;
  }, {});

  return Object.values(grouped);
};

function AribaLogs() {
  const history = useHistory();
  const [logs, setlogs] = useState([]);
  const [grupo, setGrupo] = useState("");
  const [groupsLogs, setGroupsLogs] = useState([]);
  const [groupLog, setGroupLog] = useState(null);
  const [isOpened, setIsOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState("");
  const [windowFeatures, setWindowFeatures] = useState(
    "left=0,top=0,width=1200,height=700,resizable=yes,scrollbars=yes"
  );
  const [logWindow, setLogWindow] = useState(null);

  const [nextPage, setNextPage] = useState({
    has: false,
    link: null,
  });

  const selectedGroup = logs.find((item) => item?.groupPath === grupo);
  const selectedGroupId = selectedGroup?.groupId;
  const selectedGroupLabel = selectedGroup?.groupId || selectedGroup?.label;

  const getEmpresas = async () => {
    setIsLoading(true);
    try {
      const { data } = await fetchClient.get("/ariba/getAll");
      console.log(data);
      setlogs(normalizeAribaGroups(data || []));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getEmpresas();
  }, []);

  useEffect(() => {
    if (!selectedGroupId || !type) return;
    getGroupLogs(selectedGroupId, type);
    //eslint-disable-next-line
  }, [selectedGroupId, type]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const availWidth = window.screen?.availWidth || window.innerWidth || 1600;
    const availHeight = window.screen?.availHeight || window.innerHeight || 900;
    setWindowFeatures(
      `left=0,top=0,width=${availWidth},height=${availHeight},resizable=yes,scrollbars=yes`
    );
  }, []);

  const getGroupLogs = async (tenent, logType, token = null) => {
    try {
      if (!tenent || !logType) return;
      setIsLoading(true);
      const { data } = await fetchClient.get(
        `ariba/getAllLogs/${tenent}?type=${logType}${
          token ? `&nextToken=${token}` : ""
        }`
      );
      setGroupsLogs((old) =>
        token ? [...old, ...data.logStreams] : data.logStreams
      );
      if (data.nextToken) setNextPage({ has: true, link: data.nextToken });
      else setNextPage({ has: false, link: null });
    } catch (err) {
      console.log(err);
      message.error(
        err.response?.data.message || "Erro interno, contate o suporte!"
      );
    }
    setIsLoading(false);
  };

  const handleSearch = async (search) => {
    if (!selectedGroupId) return;
    setIsLoading(true);
    const { data } = await fetchClient.post("/ariba/queryLogs", {
      queryString: search,
      type,
      group: selectedGroupId,
    });

    setGroupsLogs(data);
    setIsLoading(false);
  };

  useEffect(() => {
    setType("");
    setGroupsLogs([]);
  }, [grupo]);

  const selectedTypeLabel = LOG_TYPE_TEMPLATES.find(
    (option) => option.value === type
  )?.description;

  const closeLogWindow = () => {
    setIsOpened(false);
    setLogWindow(null);
  };

  return (
    <Container>
      {isOpened && (
        <NewWindow
          title="Logs"
          features={windowFeatures}
          onOpen={(win) => setLogWindow(win)}
          onUnload={closeLogWindow}
          onClose={closeLogWindow}
        >
          {logWindow && (
            <StyleSheetManager target={logWindow.document.head}>
              <LogEvents
                groupLog={groupLog}
                empresa={selectedGroupId}
                ariba={true}
                type={type}
              />
            </StyleSheetManager>
          )}
        </NewWindow>
      )}
      <Page>
        <PageContent>
          <ModernHeader>
            <HeaderLeft>
              <BackButton onClick={() => history.goBack()}>
                <ArrowBack />
              </BackButton>
              <HeaderContent>
                <PageTitle>
                  <Description
                    style={{ marginRight: "12px", fontSize: "32px" }}
                  />
                  Logs Ariba
                </PageTitle>
                <PageSubtitle>
                  Visualize e busque logs de eventos do sistema
                </PageSubtitle>
              </HeaderContent>
            </HeaderLeft>
            <SelectedChips>
              {selectedGroupLabel && (
                <SelectedBadge>
                  <Business style={{ fontSize: "16px", marginRight: "4px" }} />
                  {selectedGroupLabel}
                </SelectedBadge>
              )}
              {selectedTypeLabel && (
                <SelectedBadge>
                  <Category style={{ fontSize: "16px", marginRight: "4px" }} />
                  {selectedTypeLabel}
                </SelectedBadge>
              )}
            </SelectedChips>
          </ModernHeader>

          <FiltersCard>
            <SectionHeader>
              <SectionIcon color="#e67e22">
                <SearchIcon />
              </SectionIcon>
              <SectionTitle>Filtros de Busca</SectionTitle>
            </SectionHeader>
            <FormGrid>
              <StyledFieldContainer>
                <FieldLabel>
                  <Business
                    style={{
                      fontSize: "18px",
                      marginRight: "8px",
                      color: "#e67e22",
                    }}
                  />
                  Grupo
                </FieldLabel>
                <TextField
                  select
                  fullWidth
                  variant="outlined"
                  value={grupo}
                  onChange={(event) => setGrupo(event.target.value)}
                  InputLabelProps={{ shrink: true }}
                  placeholder="Selecionar grupo"
                >
                  <MenuItem value="">Selecionar grupo</MenuItem>
                  {logs.filter(Boolean).map((item) => (
                    <MenuItem key={item.id} value={item.groupPath}>
                      {item.groupId || item.label || item.id}
                    </MenuItem>
                  ))}
                </TextField>
              </StyledFieldContainer>

              <StyledFieldContainer>
                <FieldLabel>
                  <Category
                    style={{
                      fontSize: "18px",
                      marginRight: "8px",
                      color: "#e67e22",
                    }}
                  />
                  Tipo de Log
                </FieldLabel>
                <TextField
                  select
                  fullWidth
                  variant="outlined"
                  value={type}
                  onChange={(event) => setType(event.target.value)}
                  InputLabelProps={{ shrink: true }}
                  placeholder="Selecionar tipo"
                >
                  <MenuItem value="">Selecionar tipo</MenuItem>
                  {LOG_TYPE_TEMPLATES.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.description}
                    </MenuItem>
                  ))}
                </TextField>
              </StyledFieldContainer>

              <StyledFieldContainer fullWidth>
                <FieldLabel>
                  <SearchIcon
                    style={{
                      fontSize: "18px",
                      marginRight: "8px",
                      color: "#e67e22",
                    }}
                  />
                  Busca Avançada
                </FieldLabel>
                <SearchWrapper>
                  <SearchLogs
                    type={type}
                    onSearch={handleSearch}
                    tenent={selectedGroupId}
                    setLoading={setIsLoading}
                    setGroupsLogs={setGroupsLogs}
                  />
                </SearchWrapper>
              </StyledFieldContainer>
            </FormGrid>
            <FilterHelper>
              <Event style={{ fontSize: "16px", marginRight: "8px" }} />
              Defina o grupo e o tipo antes de consultar. Utilize a busca para
              localizar termos específicos dentro dos eventos.
            </FilterHelper>
          </FiltersCard>

          {isLoading ? (
            <LoaderWrapper>
              <Loader />
            </LoaderWrapper>
          ) : !grupo || !type ? (
            <ResultsCard>
              <EmptyState>
                <Description
                  style={{
                    fontSize: "48px",
                    color: "#cbd5e1",
                    marginBottom: "16px",
                  }}
                />
                <EmptyTitle>Nenhum filtro selecionado</EmptyTitle>
                <EmptyText>
                  Escolha um grupo e um tipo de log para visualizar os eventos
                  disponíveis.
                </EmptyText>
              </EmptyState>
            </ResultsCard>
          ) : (
            <ResultsCard>
              <SectionHeader>
                <SectionInfo>
                  <SectionTitle>Streams recentes</SectionTitle>
                  <SectionSubtitle>
                    {groupsLogs.length > 0
                      ? `Mostrando ${groupsLogs.length} ${
                          groupsLogs.length === 1 ? "stream" : "streams"
                        }`
                      : "Nenhum stream encontrado"}
                  </SectionSubtitle>
                </SectionInfo>
                {nextPage.has && <Tag>Mais resultados disponíveis</Tag>}
              </SectionHeader>
              {groupsLogs.length === 0 ? (
                <EmptyState>
                  Nenhum registro encontrado para essa combinação. Ajuste os
                  filtros ou tente novamente mais tarde.
                </EmptyState>
              ) : (
                <>
                  <TableWrapper>
                    <StreamsTable>
                      <thead>
                        <tr>
                          <TableHead>ID do stream</TableHead>
                          <TableHead>Último evento</TableHead>
                          <TableHead align="right">Ações</TableHead>
                        </tr>
                      </thead>
                      <tbody>
                        {groupsLogs.map(
                          ({ logStreamName, lastEventTimestamp }) => (
                            <TableRow key={logStreamName}>
                              <StreamName title={logStreamName}>
                                {logStreamName}
                              </StreamName>
                              <EventTime>
                                {moment(lastEventTimestamp).format(
                                  "DD/MM/YYYY HH:mm"
                                )}
                              </EventTime>
                              <TableActions>
                                <ConsultResult
                                  onClick={() => {
                                    setGroupLog(logStreamName);
                                    setIsOpened(true);
                                  }}
                                >
                                  Consultar
                                </ConsultResult>
                              </TableActions>
                            </TableRow>
                          )
                        )}
                      </tbody>
                    </StreamsTable>
                  </TableWrapper>
                  {nextPage.has && (
                    <MoreWrapper>
                      <MoreButton
                        onClick={() =>
                          getGroupLogs(selectedGroupId, type, nextPage.link)
                        }
                      >
                        Carregar mais
                      </MoreButton>
                    </MoreWrapper>
                  )}
                </>
              )}
            </ResultsCard>
          )}
        </PageContent>
      </Page>
    </Container>
  );
}

export default AribaLogs;

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const MoreButton = styled.button`
  min-width: 180px;
  height: 44px;
  border: none;
  background: linear-gradient(135deg, #e67e22 0%, #d35400 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 12px;
  padding: 0 32px;
  cursor: pointer;
  font-family: "Mulish", sans-serif;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(230, 126, 34, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(230, 126, 34, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #c7d3e3;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

const ConsultResult = styled.button`
  background: linear-gradient(135deg, #e67e22 0%, #d35400 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Mulish", sans-serif;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(230, 126, 34, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(230, 126, 34, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ResultsCard = styled.div`
  width: 100%;
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  animation: ${fadeIn} 0.5s ease;
  transition: all 0.3s ease;
  box-sizing: border-box;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  width: 100%;
  box-sizing: border-box;
`;

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 65px);
  padding: 24px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  font-family: "Mulish", sans-serif;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const Page = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  box-sizing: border-box;
`;

const ModernHeader = styled.div`
  padding: 24px 0;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  animation: ${fadeIn} 0.6s ease;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 0;
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const PageTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 6px 0;
  display: flex;
  align-items: center;
  font-family: "Mulish", sans-serif;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const PageSubtitle = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
  font-family: "Mulish", sans-serif;
`;

const BackButton = styled.button`
  background: rgba(230, 126, 34, 0.1);
  border: none;
  border-radius: 12px;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #e67e22;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(230, 126, 34, 0.2);
    transform: translateX(-4px);
  }

  &:active {
    transform: translateX(0);
  }
`;

const SelectedChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SelectedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background: linear-gradient(
    135deg,
    rgba(230, 126, 34, 0.1) 0%,
    rgba(211, 84, 0, 0.1) 100%
  );
  color: #e67e22;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  font-family: "Mulish", sans-serif;
  border: 1px solid rgba(230, 126, 34, 0.2);
  transition: all 0.3s ease;

  &:hover {
    border-color: #e67e22;
    background: linear-gradient(
      135deg,
      rgba(230, 126, 34, 0.15) 0%,
      rgba(211, 84, 0, 0.15) 100%
    );
  }
`;

const FiltersCard = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  animation: ${fadeIn} 0.5s ease 0.1s both;
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
  width: 100%;
  box-sizing: border-box;
`;

const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.color ? `${props.color}15` : "rgba(230, 126, 34, 0.1)"};
  color: ${(props) => props.color || "#e67e22"};
  margin-right: 12px;
  transition: all 0.3s ease;

  svg {
    font-size: 22px;
  }

  ${FiltersCard}:hover & {
    transform: scale(1.1);
  }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: "Mulish", sans-serif;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: ${(props) => (props.fullWidth ? "1 / -1" : "auto")};

  .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(230, 126, 34, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(230, 126, 34, 0.2);
    }
  }

  .MuiInputLabel-outlined {
    font-family: "Mulish", sans-serif;
    font-weight: 500;
  }

  .MuiOutlinedInput-input {
    font-family: "Mulish", sans-serif;
  }
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-family: "Mulish", sans-serif;
`;

const SearchWrapper = styled.div`
  width: 100%;
  > div {
    width: 100%;
  }
`;

const FilterHelper = styled.div`
  margin-top: 20px;
  padding: 14px 18px;
  background: linear-gradient(
    135deg,
    rgba(230, 126, 34, 0.05) 0%,
    rgba(211, 84, 0, 0.05) 100%
  );
  border-left: 4px solid #e67e22;
  border-radius: 8px;
  font-size: 13px;
  color: #5c6b7a;
  font-family: "Mulish", sans-serif;
  display: flex;
  align-items: center;
  line-height: 1.5;
`;

const SectionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SectionSubtitle = styled.span`
  font-size: 14px;
  color: #64748b;
`;

const Tag = styled.span`
  background: #e3f7ff;
  color: #05668d;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: 12px;
  box-sizing: border-box;
`;

const StreamsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 520px;
`;

const TableHead = styled.th`
  text-align: ${(props) => props.align || "left"};
  font-size: 13px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6b7280;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #eef2f7;
  &:hover {
    background: #f9fbff;
  }
`;

const StreamName = styled.td`
  font-weight: 600;
  color: #0f172a;
  padding: 12px 16px;
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const EventTime = styled.td`
  padding: 12px 16px;
  color: #4c5968;
  font-size: 14px;
`;

const TableActions = styled.td`
  padding: 12px 16px;
  text-align: right;
`;

const MoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

const EmptyState = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 64px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: "Mulish", sans-serif;
`;

const EmptyTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 8px 0;
  font-family: "Mulish", sans-serif;
`;

const EmptyText = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
  max-width: 400px;
  line-height: 1.5;
  font-family: "Mulish", sans-serif;
`;
